module.exports = __webpack_public_path__ + "img/eg8.4c4bc0f5.png";